import { html, LitElement, css, unsafeCSS } from 'lit';
import styles from './appLink.scss?inline';
import { ATTRIBUTES, EVENTS } from './constants';

export default class SotbitAppLink extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        href: { type: String },
        label: { type: String },
        name: { type: String },
        interceptClick: {
            type: Boolean,
            attribute: ATTRIBUTES.INTERCEPT_CLICK,
        },
    };

    constructor() {
        super();

        this.interceptClick = false;
    }

    handleClick(e) {
        if (this.interceptClick) {
            e.preventDefault();

            this.dispatchEvent(
                new CustomEvent(EVENTS.CLICK, {
                    bubbles: true,
                    composed: true,
                    detail: {
                        originalEvent: e,
                    },
                })
            );
        }
    }

    renderContent() {
        return html`
            <div class="outline"></div>
            <div class="app-link__icon-box">
                <slot name="icon" class="app-link__icon"></slot>
            </div>
            <div class="app-link__text">
                <span class="app-link__label">${this.label}</span>
                <span class="app-link__name">${this.name}</span>
            </div>
        `;
    }

    render() {
        return html`
            ${this.href
                ? html` <a class="app-link" href="${this.href}" target="_blank"> ${this.renderContent()} </a> `
                : html` <div class="app-link">${this.renderContent()}</div> `}
        `;
    }
}
